import React, { useEffect, useRef, useState } from 'react';
import { enableTwoFA, verifyTwoFA } from '../../../../services/auth/2FA';
import QRCode from 'react-qr-code';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import 'primereact/resources/themes/saga-blue/theme.css'; 
import 'primereact/resources/primereact.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserRole, clearUser } from '../../../../redux/userSlice';
import { Toast } from 'primereact/toast';
import { FaSignOutAlt } from 'react-icons/fa';
const TwoFactorAuthorization = () => {
  const [loading, setLoading] = useState(false);
  const [enableRes, setEnableRes] = useState('');
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [showQRCodeSection, setShowQRCodeSection] = useState(false);
  const [showVerificationCodeInput, setShowVerificationCodeInput] = useState(false);

  const accessToken = JSON.parse(localStorage.getItem('access_token'));
  const { role, id } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useRef(null);

  useEffect(() => {
      handleEnableTwoFactorAuth();
  },[]);
  


  const handleEnableTwoFactorAuth = async () => {
    setLoading(true); 
    try {
      const response = await enableTwoFA(accessToken);
      if (response) {
        setEnableRes(response?.data);
  
        if (response?.data?.message === 'Scan QR code and verify to enable 2FA' && response?.data?.status === true) {
          setIsConfirmationOpen(true);
        } else {
          setIs2FAEnabled(true);
          setShowVerificationCodeInput(true);
          setShowQRCodeSection(false);
        }
      }
  
    } catch (err) {
      setErrorMessage(`Error: ${err.message || 'Unknown error occurred'}`);
      console.error('Error occurred while enabling 2FA:', err.message);
    } finally {
      setLoading(false);
    }
  };
  

  const handleEnable2FA = () => {
    setQrCodeUrl(enableRes?.data);
    setShowQRCodeSection(true);
    setIsConfirmationOpen(false);
  };

  const handleVerifyTwoFA = async () => {
    try {
      const response = await verifyTwoFA(verificationCode, accessToken);
      
      if (response.status === 200) {
        toast.current.show({ className: 'bg-green-300 text-white', severity: 'success', summary: 'Success', detail: response.data.message, life: 3000 });
        await dispatch(fetchUserRole(accessToken)).unwrap();
        setIs2FAEnabled(true);
        navigate('/');

      } else {
        throw new Error('Verification failed');
      }
    } catch (err) {
      setErrorMessage('Verification failed. Please try again.');
      toast.current.show({ className: 'bg-yellow-700 text-white', severity: 'warn', summary: 'Warning', detail: err.message, life: 3000 });
    }
  };

  const handleDecline2FA = () => {
    const lskey = `skip_2fa_${id}`;
    localStorage.setItem(lskey, true);
    setIsConfirmationOpen(false);
    navigate('/');
  };

  const confirmationFooter = (
    <div>
      <button className="px-6 py-2 bg-transparent border text-white border-secondary hover:bg-secondary hover:text-primary rounded-lg" onClick={handleDecline2FA} >Skip</button>
      <button className="px-6 py-2 text-primary bg-secondary hover:bg-secondary rounded-lg" onClick={handleEnable2FA} >Yes</button>
    </div>
  );

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    dispatch(clearUser());
    navigate("/signin");
  };

  return (
    <>
    <div className={`fixed top-3 right-4 ${is2FAEnabled ? 'block' : 'hidden'}`}>
        <button onClick={handleLogout} className='flex gap-1 items-center text-red-200 bg-transparent text-gray-100 border border-red-200 hover:bg-red-200 hover:text-primary rounded-lg p-2'>
          <FaSignOutAlt/>
        <span>Log out</span>
        </button>
    </div>
    <Toast ref={toast} />
    <div className="text-center h-[100vh] flex items-center flex-col justify-center bg-primary text-white">
      <h1 className="text-3xl mb-4">Two-Factor Authorization</h1>
      {loading ? (
        <p>Loading...</p>
      ) : errorMessage ? (
        <p className="text-red-500">{errorMessage}</p>
      ) : is2FAEnabled ? (
        <p className="text-lg">Two-Factor Authentication is already enabled on your account.</p>
      ) : (
        <p>Enable Two-Factor Authentication to secure your account.</p>
      )}

      <Dialog
        visible={isConfirmationOpen}
        style={{ width: '450px' }}
        header="Enable Two-Factor Authentication"
        modal
        footer={confirmationFooter}
        onHide={() => {
          setIsConfirmationOpen(false);
          handleDecline2FA();
        }}
      >
        <p>Do you want to enable Two-Factor Authentication (2FA)?</p>
      </Dialog>

      {showQRCodeSection && (
        <div className="qr-code-section mt-3">
          <p>Use any Authenticator app and enter the verification code:</p>
          <p>Scan the QR code below</p>
          <div className="qr-code-card mt-4 flex justify-center p-4 shadow-lg rounded-lg">
    <QRCode value={qrCodeUrl} className='bg-transparent border border-4' />
  </div>
        </div>
      )}
<div className='flex items-center flex-col gap-3'>
      {(showVerificationCodeInput || showQRCodeSection) && (
        
        <div className="mt-4">
          <div className="w-full flex items-end gap-2">
            <input
              type="number"
              name="verificationCode"
              placeholder="Enter verification code"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              className="block w-full p-3 bg-transparent text-gray-100 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
        </div>
      )}

      <div className="mt-4">
      {isConfirmationOpen ? (
        ""
      ) :
        <button type="submit" className="px-6 py-2 text-primary bg-secondary hover:bg-secondary rounded-lg" icon="pi pi-check" onClick={handleVerifyTwoFA} disabled={!verificationCode} >Submit</button>}
       {showQRCodeSection && !isConfirmationOpen && <button type="cancel" className='ml-2 bg-transparent text-gray-100 border border-secondary hover:bg-secondary hover:text-primary rounded-lg px-6 py-2 ' icon="pi pi-check" onClick={handleDecline2FA} >Cancel</button>}
      </div>
      </div>
    </div>
    </>
  );
};

export default TwoFactorAuthorization;
